module.exports = __webpack_public_path__ + "app-static/img/13.b1a9fb6a.png";